import constants from "../constants/constants";
import Awards from "./awards.component";
import ScrollDownIndicator from "./scrollDownloadIndicator";
import { Link } from "react-router-dom";
import { useUserParams } from "../hooks/useUserParams";

export default function Hero() {
    const { getCurrentAgentName, getCurrentQuote, getCurrentBrokerage } = useUserParams();
    return (
        <div
            className="w-full bg-no-repeat bg-cover h-screen flex items-center justify-start relative"
            style={{ backgroundImage: `url(${constants.HOME_IMAGE})` }}
        >
            <div className="flex flex-col sm:flex-col items-start sm:items-start gap-8 sm:gap-12 pl-8 sm:pl-16">
                <div className="p-8 sm:p-12 bg-logo-main w-full sm:w-[32rem] max-w-lg rounded-lg shadow-lg">
                    <h1 className="text-white text-4xl sm:text-6xl font-serif font-bold">
                        {getCurrentAgentName()}
                    </h1>
                    <h4 className="text-white text-2xl font-mont mt-5 whitespace-normal">
                        {getCurrentQuote()}
                    </h4>
                    <p className="text-white text-lg font-mont mt-4">
                        {getCurrentBrokerage()}
                    </p>
                </div>
                <div className="flex flex-col sm:flex-row items-start sm:items-start gap-8 sm:gap-12">
                    <Link
                        to="/about"
                        className="w-40 h-16 bg-logo-second text-logo-main font-bold text-lg rounded-none shadow-lg hover:bg-logo-main hover:text-white hover:border-2 hover:border-nature-brown transition-colors duration-200 flex items-center justify-center text-center mt-6 sm:mt-0"
                    >
                        Learn More
                    </Link>
                    <Link
                        to="/listings"
                        className="w-40 h-16 bg-nature-brown text-white font-bold text-lg rounded-none shadow-lg border-2 border-transparent hover:border-nature-brown hover:bg-logo-main hover:text-white transition-colors duration-200 flex items-center justify-center text-center mt-6 sm:mt-0"
                    >
                        Listings
                    </Link>
                </div>
            </div>
        </div>
    );
}
